import React from 'react';
import { spriteClasses } from '@stencil/flights-constants/src/text';
import CarrierSprite from '@stencil/carrier-sprite';

// import CheckInIcon from '../../../icons/CheckIn';
import RupeeIcon from '../../../icons/Rupee';

import * as S from './details-section.styles';

const FlightCard = props => {
  const { handleFlightSelection, flightItem } = props;
  const {
    returnFlight,
    carrierLogoArr,
    carrierNameArr,
    flightArr,
    arrivalDetails,
    duration,
    price,
    footerText
  } = flightItem;

  const handleFlightCardSelection = () => {
    handleFlightSelection(flightItem);
  };

  const getLayoverText = flights => {
    const carrierNameText = `${flights
      .slice(1)
      .map(f => `${f.depText} ${f.layoverInfo}`)
      .join(', ')}`;
    return `Layover${flights.length > 2 ? 's' : ''} - ${carrierNameText}`;
  };

  const viaText = flights => {
    return flights.length > 1
      ? `${flights
          .slice(1)
          .map(f => f.depCode)
          .join(' - ')}`
      : '';
  };

  return (
    <S.ListWrap onClick={handleFlightCardSelection}>
      {returnFlight ? (
        <>
          <p className="dF alignItemsCenter marginB10">
            {carrierLogoArr.map((carrierCode, index) =>
              spriteClasses.indexOf(`carrier${carrierCode}`) > -1 ? (
                <CarrierSprite key={index} className={`carrier${carrierCode}`} />
              ) : (
                <S.CarrierLogo
                  key={index}
                  src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrierCode}.png`}
                  alt=""
                />
              )
            )}
            <span className="marginL10">
              {carrierNameArr.length > 1 ? 'Multi-Airline' : carrierNameArr}
            </span>
          </p>
          <div className="dF alignItemsCenter justifyBetween marginB15">
            <div>
              {flightArr.length > 1 ? (
                <p className="font10 marginB5">
                  {flightArr[0].depCode}
                  <span> - </span>
                  {viaText(flightArr)}
                  <span> - </span>
                  {arrivalDetails.arrCode}
                </p>
              ) : (
                <p className="font10 marginB5">
                  {flightArr[0].depCode}
                  <span> - </span>
                  {arrivalDetails.arrCode}
                </p>
              )}
              <p className="marginB5">
                <span className="font14 fb black">{flightArr[0].depTime}</span>{' '}
                <span className="black marginL10 marginR10">{duration}</span>{' '}
                <span className="font14 fb black">{arrivalDetails.arrTime}</span>{' '}
                {arrivalDetails.arrDayDiff > 0 ? (
                  <span className="grey font10">&#43;{arrivalDetails.arrDayDiff}D</span>
                ) : null}
              </p>
              <p className="font10 grey">
                {flightArr.length > 1 ? (
                  <span className="black">{getLayoverText(flightArr)}</span>
                ) : null}
              </p>
            </div>
          </div>
          <p className="grey font11 dF">
            {footerText && (
              <span className="marginR7 dF alignItemsCenter">
                {/* <CheckInIcon width="1.6rem" height="1.6rem" fill="#2276E3" />{' '} */}
                <span className="go_blue">{footerText}</span>
              </span>
            )}
          </p>
          <span className="pricing dF justifyEnd" style={{ marginTop: '2rem' }}>
            ₹{price}
            <span className="arrow"></span>
          </span>
          <p className="dF alignItemsCenter marginB10">
            {returnFlight.carrierLogoArr.map((carrierCode, index) =>
              spriteClasses.indexOf(`carrier${carrierCode}`) > -1 ? (
                <CarrierSprite key={index} className={`carrier${carrierCode}`} />
              ) : (
                <S.CarrierLogo
                  key={index}
                  src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrierCode}.png`}
                  alt=""
                />
              )
            )}
            <span className="marginL10">
              {returnFlight?.carrierNameArr.length > 1
                ? 'Multi-Airline'
                : returnFlight?.carrierNameArr}
            </span>
          </p>
          <div className="dF alignItemsCenter justifyBetween marginB15">
            <div>
              {returnFlight.flightArr.length > 1 ? (
                <p className="font10 marginB5">
                  {returnFlight.flightArr[0].depCode}
                  <span> - </span>
                  {viaText(returnFlight.flightArr)} <span> - </span>
                  {returnFlight.arrivalDetails.arrCode}
                </p>
              ) : (
                <p className="font10 marginB5">
                  {returnFlight.flightArr[0].depCode}
                  <span> - </span>
                  {returnFlight.arrivalDetails.arrCode}
                </p>
              )}
              <p className="marginB5">
                <span className="font14 fb black">{returnFlight.flightArr[0].depTime}</span>{' '}
                <span className="black marginL10 marginR10">{returnFlight.duration}</span>{' '}
                <span className="font14 fb black">{returnFlight.arrivalDetails.arrTime}</span>{' '}
                {returnFlight.arrivalDetails.arrDayDiff > 0 ? (
                  <span className="grey font10">
                    &#43;{returnFlight.arrivalDetails.arrDayDiff}D
                  </span>
                ) : null}
              </p>
              <p className="font10 grey">
                {returnFlight.flightArr.length > 1 ? (
                  <span className="black">{getLayoverText(returnFlight.flightArr)}</span>
                ) : null}
              </p>
            </div>
          </div>
          <p className="grey font11 dF">
            {footerText && (
              <span className="marginR7 dF alignItemsCenter">
                {/* <CheckInIcon width="1.6rem" height="1.6rem" fill="#2276E3" />{' '} */}
                <span className="go_blue">{footerText}</span>
              </span>
            )}
          </p>
        </>
      ) : (
        <>
          <p className="dF alignItemsCenter marginB10">
            {' '}
            {carrierLogoArr.map((carrierCode, index) =>
              spriteClasses.indexOf(`carrier${carrierCode}`) > -1 ? (
                <CarrierSprite key={index} className={`carrier${carrierCode}`} />
              ) : (
                <S.CarrierLogo
                  key={index}
                  src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrierCode}.png`}
                  alt=""
                />
              )
            )}
            <span className="marginL10">
              {carrierNameArr.length > 1 ? 'Multi-Airline' : carrierNameArr}
            </span>
          </p>
          <div className="dF alignItemsCenter justifyBetween marginB15">
            <div>
              {flightArr.length > 0 ? (
                <p className="font10 marginB5">
                  {flightArr[0].depCode}
                  <span> - </span>
                  {viaText(flightArr)}
                  {flightArr.length > 1 ? <span> - </span> : ''}
                  {arrivalDetails.arrCode}
                </p>
              ) : null}
              <p className="marginB5">
                <span className="font14 fb black">{flightArr[0].depTime}</span>{' '}
                <span className="black marginL10 marginR10">{duration}</span>{' '}
                <span className="font14 fb black">{arrivalDetails.arrTime}</span>{' '}
                {arrivalDetails.arrDayDiff > 0 ? (
                  <span className="grey font10">&#43;{arrivalDetails.arrDayDiff}D</span>
                ) : null}
              </p>
              <p className="font10 grey">
                {flightArr.length > 1 ? (
                  <span className="black">{getLayoverText(flightArr)}</span>
                ) : null}
              </p>
            </div>
            <span className="pricing">
              <RupeeIcon width="1rem" height="1rem" fill="#0b69e3" />
              {price}
              <span className="arrow"></span>
            </span>
          </div>
          <p className="grey font11 dF">
            {footerText && (
              <span className="marginR7 dF alignItemsCenter">
                {/* <CheckInIcon width="1.6rem" height="1.6rem" fill="#2276E3" />{' '} */}
                <span className="go_blue">{footerText}</span>
              </span>
            )}
          </p>
        </>
      )}
    </S.ListWrap>
  );
};
export default FlightCard;
